import { deleteLocalStorage, getLocalStorage, getLocalStorages } from "./localStorage";
import { isNative } from "../../native/platform";
import { clearReadCache } from "../../offline";
export const setAuthentication = (user, token, refreshToken) => {
  localStorage.setItem("user", JSON.stringify(user));
  localStorage.setItem("token", token);
  localStorage.setItem("refreshToken", refreshToken);
};
export const isAuthenticated = () => {
  if (getLocalStorages("user") && getLocalStorage("token")) {
    var user = getLocalStorages("user");
    return {
      ...user,
      employeeId: user.role == 1 ? user._id : user?.employer?._id,
      serviceProviderId: user.role == 1 ? user.user : user._id
    }
  } else {
    return false;
  }
};
export const logout = () => {
  // Data kept for offline use belongs to this user; queued changes stay for their next login
  clearReadCache();
  deleteLocalStorage("user");
  deleteLocalStorage("token");
  deleteLocalStorage("refreshToken");
};

export const getDomainFromToken = () => {
  try {
    const token = localStorage.getItem("token");
    if (!token) return null;
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.domain || null;
  } catch {
    return null;
  }
};

// Back to the login the user came from: the portal that sent them (sourceDomain), else their
// tenant's own site. In the app there is no site to go to, so it stays on its own login screen
// (an external URL would open the system browser).
export const logoutAndRedirect = () => {
  let redirectUrl = "https://leistfusion.de/login";
  const sourceDomain = localStorage.getItem("sourceDomain");
  if (isNative) {
    redirectUrl = "/login";
  } else if (sourceDomain) {
    redirectUrl = `${sourceDomain}/login`;
  } else {
    const tokenDomain = getDomainFromToken();
    if (tokenDomain) {
      try {
        redirectUrl = `${new URL(tokenDomain).origin}/login`;
      } catch {
        // malformed domain claim: fall back to the default login
      }
    }
  }
  logout();
  window.location.href = redirectUrl;
};
